import { render, staticRenderFns } from "./penerimaankas.vue?vue&type=template&id=93be9978&scoped=true&"
import script from "./penerimaankas.vue?vue&type=script&lang=js&"
export * from "./penerimaankas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93be9978",
  null
  
)

export default component.exports